import { createApiRef } from '@backstage/core-plugin-api';
import { DefaultApiClient } from '@internal/plugin-eventstatus-common';

export const eventStatusApiRef = createApiRef<DefaultApiClient>({
  id: 'plugin.eventstatus.service',
});
